import { mapProductCompliance, RawProductCompliance } from '~/Api/CzSuklCompliance';
import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';

import mapReferencePrice, { RawReferencePrice } from './mapReferencePrice';
import Product from './Product';
import ProductDataSource from './ProductDataSource';

export interface RawProduct {
	product: RawGeneralProduct;
	datasource: { type: string; suklReference: boolean };
	referencePrices: RawReferencePrice[];
	packageSizeForSingleUnit: number | null;
	singleUnitPackageSize: boolean | null;
	productCompliance: RawProductCompliance;
	selected?: boolean;
}

export default function mapProduct(product: RawProduct): Product {
	return new Product(
		mapGeneralProduct(product.product),
		new ProductDataSource(product.datasource.type, product.datasource.suklReference),
		product.referencePrices.map(mapReferencePrice),
		product.packageSizeForSingleUnit,
		Boolean(product.singleUnitPackageSize),
		Boolean(product.selected),
		mapProductCompliance(product.productCompliance)
	);
}
